export const formFieldId = (fieldName: string, fieldComponent: string) => {
  return `${fieldName ?? 'formField'}${fieldComponent}`.replace(/[^a-z0-9]/gi, '');
};
